 <span  *ngIf ="is_vw_creative " ><h4 class="mb-3" style="margin-top: 2%"> Personal Information &  Address </h4></span>

  <form [formGroup]="registerForm" (ngSubmit)="onSubmit()" enctype='multipart/form-data' *ngIf ="is_vw_creative" >
  
  <div class="row form-group">
      <div class="col-md-4 mb-3">
        <label for="entity_type">Profile<span>*</span></label>
        <select #mySelectEntityChange (change)='onEntityTypeChange(mySelectEntityChange.value)'   formControlName="entity_type" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.entity_type.errors }" class="custom-select d-block w-100" id="entity_type" name="entity_type" required="">
          <option value="">Choose...</option>
          <option *ngFor="let en_type of entity_types" [value]="en_type.id">{{en_type.name}}</option>
        </select>
         <div *ngIf="submitted && f.entity_type.errors" class="invalid-feedback">
            <div *ngIf="f.entity_type.errors.required"> Entity type is required.</div>
           
         </div>
      </div>
     
      <div class="col-md-4 mb-3">
        <label for="first_name">{{_firm_name}}<span>*</span> </label>
        <input type="text" maxlength="25" name="first_name" formControlName="first_name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.first_name.errors }"  class="form-control" id="first_name" placeholder="" value="" required="">
        
         <div *ngIf="submitted && f.first_name.errors" class="invalid-feedback">
            <div *ngIf="f.first_name.errors.required">Please enter a your {{_firm_name}} </div>
            <div *ngIf="f.first_name.errors.maxlength">please enter only 25 character</div>
            <div *ngIf="f.first_name.errors.minlength">please enter minimum 3 character</div>
         

         </div>   

           
        
      </div>
      <div class="col-md-4 mb-3" *ngIf ="!is_entity_company">
        <label for="last_name">Last Name <span>*</span></label>
        
         <span *ngIf="!is_entity_company; then thenlBlock else elselBlock"></span>
         <ng-template #thenlBlock>
          <input type="text" maxlength="25"  class="form-control" formControlName="last_name" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.last_name.errors }" id="last_name" placeholder="" value="">
          <div *ngIf="submitted && f.last_name.errors" class="invalid-feedback">
             <div *ngIf="f.last_name.errors.required">Last name is required</div>
             <div *ngIf="f.last_name.errors.maxlength">please enter only 25 character</div>
             <div *ngIf="f.last_name.errors.minlength">please enter minimum 3 character</div>
             <div *ngIf="f.last_name.errors.pattern">please enter letters and numbers</div>
          </div>
         </ng-template>
           

         <ng-template #elselBlock> 
          <input type="text" maxlength="25"  class="form-control" formControlName="last_name" class="form-control" id="last_name" placeholder="" value="" >
          </ng-template>

        
      </div>
     </div>
 
    <div class="row form-group">
      
      <div class="col-md-3 mb-3">
        <label for="date_of_birth">{{_dob_label}} <span>*</span> </label>
        <input type="text"
        placeholder="MM-DD-YYYY"
        class="form-control"
        name="date_of_birth"
        id="date_of_birth"
        formControlName="date_of_birth"
        value=""
        required="" 
        [ngClass]="{ 'is-invalid': submitted && f.date_of_birth.errors }"
        [minDate]="minDate"
        [maxDate]="maxDate"
        bsDatepicker 
       [bsConfig]="{ isAnimated: true,rangeInputFormat: 'MM-DD-YYYY' }" >
        <div *ngIf="submitted && f.date_of_birth.errors" class="invalid-feedback">
          <div *ngIf="f.date_of_birth.errors.required">Date of Birth is Required</div>
       </div> 

        <!-- <input type="text"  ui-mask="99/99/9999" name="date_of_birth" id="date_of_birth"  class="form-control fa fa-calendar  dob_customers" [ngClass]="{ 'is-invalid': submitted && f.date_of_birth.errors }"  id="date_of_birth" formControlName="date_of_birth" placeholder="DD-MM-YYYY" value=""  required="" >
         <div *ngIf="submitted && f.date_of_birth.errors" class="invalid-feedback">
            <div *ngIf="f.date_of_birth.errors.required">Date of Birth is Required</div>
         </div> -->
        <!-- <small><i>example: 20-04-2003</i> </small> -->
      </div>
      <div class="col-md-3 mb-3"  *ngIf ="!is_entity_company">
        <label for="marital_status">Marital Status </label>
        <span *ngIf="is_entity_company; then thenMBlock else elseMBlock"></span>
        <ng-template #thenMBlock> 
          <select  formControlName="marital_status" class="form-control"  class="custom-select d-block w-100" id="marital_status" name="marital_status">
            <option value="">Choose...</option>
            <option *ngFor="let m_type of martial_types" [value]="m_type.id">{{m_type.name}}</option>
          </select>
           
        </ng-template>
        <ng-template #elseMBlock> 
          <select  formControlName="marital_status" class="form-control"  class="custom-select d-block w-100" id="marital_status" name="marital_status">
            <option value="">Choose...</option>
            <option *ngFor="let m_type of martial_types" [value]="m_type.id">{{m_type.name}}</option>
          </select>
           
       </ng-template>


        
      </div>


      <div class="col-md-3 mb-3">
        <label for="mobile_no">Mobile Number <span>*</span> </label>
        <input  formControlName="mobile_no" maxlength="10" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.mobile_no.errors }" type="textarea" class="form-control" id="mobile_no" placeholder="" value="" required="">
        <div *ngIf="submitted && f.mobile_no.errors" class="invalid-feedback">
          <div *ngIf="f.mobile_no.errors.required">Mobile is required</div>
          <div *ngIf="f.mobile_no.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
       </div>
      </div>
      
       <div class="col-md-3 mb-3">
         <label for="email_id">Email ID <span>*</span> </label>
         <input type="textarea" formControlName="email_id" name="email_id" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email_id.errors }" class="form-control" id="email_id" placeholder="" value="" required="">
         
         <div *ngIf="submitted && f.email_id.errors" class="invalid-feedback">
          <div *ngIf="f.email_id.errors.required"> Email id is required.</div>
          <div *ngIf="f.email_id.errors.email">Email must be a valid email address</div>
       </div>
       </div>
    </div>
   
  
     
  <div class="row form-group">
    <div class="col-md-6 mb-3">
       <label for="current_residential_address">{{_cr_address_label}} <span>*</span></label>
       <input type="textarea" formControlName="current_residential_address" [ngClass]="{ 'is-invalid': submitted && f.current_residential_address.errors }"  class="form-control" id="current_residential_address" placeholder="" value="" required="">
       <div *ngIf="submitted && f.current_residential_address.errors" class="invalid-feedback">
        <div *ngIf="f.current_residential_address.errors.required"> Current Residential Address is required.</div>
        <div *ngIf="f.current_residential_address.errors.maxlength">please enter only 100 character</div>
        <div *ngIf="f.current_residential_address.errors.minlength">please enter minimum 6 character</div>
       <!-- <div *ngIf="f.current_residential_address.errors.pattern">please enter valid character</div> -->
    </div>
     </div>
     <div class="col-md-2 mb-3">

      <label for="state">State<span>*</span></label>
     
      <select #mySelectStateChange (change)='onStateChangeChange(mySelectStateChange.value)'   formControlName="state" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.state.errors }" class="custom-select d-block w-100" id="state" name="state" required="">
        <option value="">Choose...</option>
        <option *ngFor="let state_type of states_types" [value]="state_type.id">{{state_type.name | titlecase }}</option>
      </select>
       <div *ngIf="submitted && f.state.errors" class="invalid-feedback">
          <div *ngIf="f.state.errors.required"> State is required. </div>
         
       </div>


     
    </div>
    <div class="col-md-2 mb-3">
     <label for="city">City<span>*</span></label>
       <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="city" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.city.errors }" class="custom-select d-block w-100" id="city" name="city" required="">
        <option value="">Choose...</option>
        <option *ngFor="let city_type of cities_types" [value]="city_type.id">{{city_type.name}}</option>
      </select>
       <div *ngIf="submitted && f.city.errors" class="invalid-feedback">
          <div *ngIf="f.city.errors.required"> City is required. </div>
         
       </div>
    
    </div>
     <div class="col-md-2 mb-3">
      <label for="pin_code"> Pincode <span>*</span></label>
      <input type="text" maxlength="6" formControlName="pin_code"  [ngClass]="{ 'is-invalid': submitted && f.pin_code.errors }" class="form-control" id="pin_code" placeholder="" required="">
      <div *ngIf="submitted && f.pin_code.errors" class="invalid-feedback">
          <div *ngIf="f.pin_code.errors.required"> Pincode is required.</div>
          <div *ngIf="f.pin_code.errors.pattern">please enter valid pincode</div>
      </div>
    </div>
     
  </div>
  

   <h4 class="mb-3" style="margin-top: 2%" > Vehicle Information </h4>
   <div class="row form-group">
      <div class="col-md-6 mb-3">
        <label for="vehicle_name">Channel <span>*</span></label>
        <select #mySelectChannel (change)='onChannelChange(mySelectChannel.value)'  formControlName="vehicle_name" [ngClass]="{ 'is-invalid': submitted && f.vehicle_name.errors }" class="custom-select d-block w-100" id="vehicle_name" required="">
            <option value="">Choose...</option>
            <option *ngFor="let v_name of v_names" [value]="v_name.id">{{v_name.name}}</option>
          </select>
       
        <div *ngIf="submitted && f.vehicle_name.errors" class="invalid-feedback">
            <div *ngIf="f.vehicle_name.errors.required"> Vehicle name is required.</div>
          </div>
      </div>
      
      <div class="col-md-6 mb-3">
        <label for="dealer_name">Dealer Name <span>*</span></label>
        
        <select   formControlName="dealer_name" [ngClass]="{ 'is-invalid': submitted && f.dealer_name.errors }" class="custom-select d-block w-100" id="dealer_name" required="">
          <option value="">Choose...</option>
          <option *ngFor="let dealer of dealers_data" [value]="dealer.id">{{dealer.name | titlecase }}</option>
          
        </select>
         <div *ngIf="submitted && f.dealer_name.errors" class="invalid-feedback">
          <div *ngIf="f.dealer_name.errors.required"> Dealer Name is required.</div>
        </div>
       </div>
    </div>
   
    <div class="row form-group">
      <div class="col-md-4 mb-3">
        <label for="variant"> Model  <span>*</span></label>
        <select  #mySelectModel (change)='onModelVarientChange(mySelectModel.value)' formControlName="variant" [ngClass]="{ 'is-invalid': submitted && f.variant.errors }" class="custom-select d-block w-100" id="variant" required="">
            <option value="">Choose...</option>
            <option *ngFor="let vr_name of vr_names" [value]="vr_name.id">{{vr_name.name}}</option>
            
          </select>
          <div *ngIf="submitted && f.variant.errors" class="invalid-feedback">
            <div *ngIf="f.variant.errors.required"> Variant is required.</div>
          </div>
      </div>
      <div class="col-md-4 mb-3">
        <label for="color"> Variant <span>*</span> </label>
        <select formControlName="color" [ngClass]="{ 'is-invalid': submitted && f.color.errors }" class="custom-select d-block w-100" id="color" required="">
            <option value="">Choose...</option>
           
            <option *ngFor="let v_name of vc_names" [value]="v_name.id">{{v_name.name}}</option>
          </select>
          <div *ngIf="submitted && f.color.errors" class="invalid-feedback">
            <div *ngIf="f.color.errors.required"> Variant is required.</div>
          </div>
      </div>

      <div class="col-md-4 mb-3">
        <label for="tenure">Subscription Term <span>*</span></label>
        <select formControlName="tenure" [ngClass]="{ 'is-invalid': submitted && f.tenure.errors }"  class="custom-select d-block w-100" id="tenure" required="">
            <option value="">Choose...</option>
            <option *ngFor="let v_t of v_tenure" [value]="v_t.id">{{v_t.name}}</option>
        </select>
          <div   *ngIf="submitted && f.tenure.errors" class="invalid-feedback">
            <div *ngIf="f.tenure.errors.required"> Subscription Term is required.</div>
          </div>
      </div>


     
        
        
        
     </div>
     <h4 class="mb-3" style="margin-top: 2%"> Documents Information </h4> 
     <div class="row form-group">
      <div class="col-md-4 mb-3">
        <label for="pan_card_no">	Permanent Account Number.   <span>*</span>  </label>
        <input formControlName="pan_card_no" [ngClass]="{ 'is-invalid': submitted && f.pan_card_no.errors }" type="text" class="form-control" id="pan_card_no" placeholder="" value="" required="">
        <div *ngIf="submitted && f.pan_card_no.errors" class="invalid-feedback">
         <div *ngIf="f.pan_card_no.errors.required">Pan Card No is required.</div>
         <div *ngIf="f.pan_card_no.errors.pattern">Please enter valid pan card no.</div>
       </div>
      </div>
      
       <div class="col-md-4 mb-3">
         <label for="dl_no">Driving License Number (Optional)  </label>
         <input type="text" formControlName="dl_no"   class="form-control" id="dl_no" placeholder="" value="" >
        
       </div>
     </div>
     <div class="row form-group">
       

    
     <div class="col-md-4 mb-3">
       <label for="pan_card_copy">	{{_pan_card_label}}  <span>*</span>  </label>
       <input accept=".png, .jpg,.jpeg,.pdf" name="pan_card_copy" (change)="handleFileInputPan($event)" formControlName="pan_card_copy" [ngClass]="{ 'is-invalid': submitted && f.pan_card_copy.errors }" type="file" class="form-control" id="pan_card_copy" placeholder="" value="" required="">
       <div *ngIf="submitted && f.pan_card_copy.errors" class="invalid-feedback">
        <div *ngIf="f.pan_card_copy.errors.required">Pan Card Copy is required.</div>
      </div>
     </div>
     
      <div class="col-md-4 mb-3">
        <label for="dl_copy">Driving License Copy  (Optional) </label>
        <input type="file" accept=".png, .jpg,.jpeg,.pdf"   name="dl_copy" (change)="handleFileInputDL($event)"  formControlName="dl_copy"  class="form-control" id="dl_copy" placeholder="" value="" >
        
      </div>
      <div class="col-md-4 mb-3">
        <label for="residence_copy">{{_address_proof}} (Optional) 								
        </label>
        <input type="file" accept=".png, .jpg,.jpeg,.pdf" name="residence_copy" (change)="handleFileInputResidental($event)"  formControlName="residence_copy"  class="form-control" id="residence_copy" placeholder="" value="" >
        <!-- <div *ngIf="submitted && f.residence_copy.errors" class="invalid-feedback">
            <div *ngIf="f.residence_copy.errors.required">Residence Address Proof Copy is required.</div>
          </div> -->
      </div>
      
  </div>
  
    
   

   <div>
    <h4 class="mb-3">Declaration</h4>
   
     <p> - I/We declare that all particulars and information given in the Enquiry Form (“Application Form/Application”) are true, correct and complete and that they shall form the basis of any Subscription/Lease ORIX may decide to grant to me/us.</p>
<!-- <p>
  - I/We confirm that I/We have had no insolvency/bankruptcy proceedings against me/us. I/We have never ever been adjudicated insolvent/bankrupt. I/We agree that ORIX may take up such references and make such enquires in respect of this Application, as it may deem necessary.
</p> -->
<!-- <p>
  I/we undertake to inform ORIX regarding any change in my/our addresses (current and permanent)/contact details and my/our occupation/employment/ employer and to provide any further information
</p> -->
<p>
  - I/We confirm that ORIX may make available any information contained in this Application Form and other documents submitted to ORIX and information pertaining to the Subscription/Lease offered by ORIX to any Government Agencies, Rating Agencies, Credit Bureaus, Regulators and other institutions as it may deem fit and /or as required by the law. ORIX may seek/receive information from any source/person to consider this Application.
</p>
<p>
  - I/We further agree that my/our Application for Subscription/Lease of vehicles offered by ORIX shall be governed by rules/norms/policy of ORIX which may be in force, from time to time and ORIX shall be entitled to reject or accept my/our Application at its sole discretion without assigning any reasons therefore.
</p>

       
   </div>

   <div class="row form-group">
    <div class="col-md-3 mb-3">
    
      
       <input formControlName="terms_and_condition" [ngClass]="{ 'is-invalid': submitted && f.terms_and_condition.errors }" type="checkbox" id="terms_and_condition" placeholder="" value="" required="">
       <label for="terms_and_condition" style="margin-left: 5px;"> I Agree <span> * </span>	</label>
       <div *ngIf="submitted && f.terms_and_condition.errors" class="invalid-feedback">
       <div *ngIf="f.terms_and_condition.errors.required"> Please select, I Agree </div>
     </div>
    </div>
    
      <div class="col-md-6 mb-3"  >
        <input  type="text" formControlName="otp_request"  name ="otp_request" class="form-control"  [ngClass]="{ 'is-invalid': submitted && f.otp_request.errors }"  id="otp_request" placeholder="Please enter your OTP" value="" required="">
        <div *ngIf="submitted && f.otp_request.errors" class="invalid-feedback">
          <div *ngIf="f.otp_request.errors.required"> Please enter your OTP </div>
          </div>
         </div>
    
      <div class="col-md-3 mb-3"  >
        <button  type="button" style="float: right;" role="status" class="  btn btn-primary pull-right " [disabled]="_request_otp_no" (click)="sendOtpToCustomer()" id="btn-one">Get OTP</button>
      </div>
    
     
 </div>
   <hr class="mb-4">
   <div class="row form-group">
       <div class="col-md-12 col-sm-12 mb-3 ">
         <div *ngIf="isSaving" id="preloader"><div data-loader="dual-ring"></div></div>
         
         <button class="btn btn-primary pull-right" [hidden]="_request_otp_no == '' "      style="float: right;" type="submit" id="btn-one" > Verify OTP & Submit</button>
           <small>All fields are mandatory*</small>
          </div>
       
   </div>
   
  <div class="text-left" style=" border: solid 1px #999999; border-radius: 6px; padding: 20px; ">
    <h2>OUR LEASE SUBSCRIPTION PARTNER</h2>
    <div class="d-flex justify-content-between">
      <div >
        <img src="https://marutisuzukiarenaprodcdn.azureedge.net/-/media/sharedmobilitywp/orix_logo_highr.ashx?rev=2d782b6a1fb74dad821f38f92eb76fba"  class="img-responsive" style="width:auto; height:150px; padding:10px 0 0 0;" alt="Orix" >
      </div>
    
       <div>
        <p style="padding: 50px 20px 0 20px;">We have partnered with Orix Auto Infrastructure Services Limited, one of India's leading leasing companies, to provide you an easy and hassle-free subscription experience.</p>
      </div> 
    </div>
    
  </div>


   <span id="otp_send_msg"  data-toggle="modal" data-target="#otp_send_msg_pop">  </span>

   <div id="otp_send_msg_pop" class="modal fade" role="dialog" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content ">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Information!!</h4>
        </div>
         <div class="modal-body">
          
            {{_msg_otp}}
           
            </div>
       </div>
     </div>
   </div>
   <span id="invalid_send_msg"  data-toggle="modal" data-target="#invalid_send_msg_pop"></span>

   <div id="invalid_send_msg_pop" class="modal fade" role="dialog" aria-hidden="true" style="top:-30px">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Information!!</h4>
        </div>
         <div class="modal-body">
            
              {{_valid_otp}}
            
            </div>
       </div>
     </div>
   </div>
  </form>


   <span id="booking_confirm_send_msg"  data-toggle="modal" data-target="#booking_confirm_send_msg_pop"></span>

   <div id="booking_confirm_send_msg_pop" class="modal fade" role="dialog" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Congratulations !!</h4>
        </div>
         <div class="modal-body">
            
          <p>Welcome to Maruti Suzuki Subscribe, a Surprisingly Easy way for you to choose, drive and enjoy a Maruti Suzuki car of your choice! Explore an innovative way to bring home a car and know everything about our subscription services with the attached brochure. </p>
                     
          <p>Our Leasing Partner – ORIX is all set to support you through your subscription journey </p>

           <p>Our partners will be in touch with you shortly, for document collection and subscription payments.</p> 
           <p>{{_booking_no}} </p>
            </div>
       </div>
     </div>
   </div>


  


   <span id="contact_us_form_msg"  data-toggle="modal" data-target="#contact_us_form_msg_pop"></span>

   <div id="contact_us_form_msg_pop" class="modal fade" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
     <div class="modal-dialog modal-dialog-centered"  role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          
          <h5 class="modal-title">Maruti Suzuki Subscribe </h5>
          <p>Below information will be forwarded Maruti or its partners subject to the company policy.</p>
        </div>
         <div class="modal-body">
          
          <p>Please Provide us your contact details.</p>
          <form [formGroup]="contactUsForm" (ngSubmit)="onContactUsSubmit()" enctype='multipart/form-data'>
            <div class="row form-group">
              <div class="col-md-6 mb-6">
                <label for="email_id">Email ID <span>*</span> </label>
                <input type="textarea" formControlName="email_id" name="email_id" class="form-control" [ngClass]="{ 'is-invalid': cosubmitted && co.email_id.errors }" class="form-control" id="email_id" placeholder="" value="" required="">
                
                <div *ngIf="cosubmitted && co.email_id.errors" class="invalid-feedback">
                 <div *ngIf="co.email_id.errors.required"> Email id is required.</div>
                 <div *ngIf="co.email_id.errors.email">Email must be a valid email address</div>
              </div>
              </div>

              <!-- <div class="col-md-6 mb-6">
                    <label for="first_name">First Name<span>*</span> </label>
                    <input type="text" maxlength="25" name="first_name" formControlName="first_name" class="form-control" [ngClass]="{ 'is-invalid': cosubmitted && co.first_name.errors }"  class="form-control" id="first_name" placeholder="" value="" required="">
                    <div *ngIf="cosubmitted && co.first_name.errors" class="invalid-feedback">
                    <div *ngIf="co.first_name.errors.required">Please enter a your first name </div>
                    <div *ngIf="co.first_name.errors.maxlength">please enter only 25 character</div>
                    <div *ngIf="co.first_name.errors.minlength">please enter minimum 3 character</div>
                   </div> 
              </div> -->
              
                
                <!-- <div class="col-md-6 mb-6">
                  <label for="last_name">Last Name<span>*</span> </label>
                  <input type="text" maxlength="25" name="last_name" formControlName="last_name" class="form-control" [ngClass]="{ 'is-invalid': cosubmitted && co.last_name.errors }"  class="form-control" id="last_name" placeholder="" value="" required="">

                  <div *ngIf="cosubmitted && co.last_name.errors" class="invalid-feedback">
                  <div *ngIf="co.last_name.errors.required">Please enter a your last name </div>
                  <div *ngIf="co.last_name.errors.maxlength">please enter only 25 character</div>
                  <div *ngIf="co.last_name.errors.minlength">please enter minimum 3 character</div>

                  </div> 
               </div> -->


                <div class="col-md-6 mb-6">
                  <label for="mobile_no">Mobile Number <span>*</span> </label>
                  <input  formControlName="mobile_no" maxlength="10" class="form-control" [ngClass]="{ 'is-invalid': cosubmitted && co.mobile_no.errors }" type="textarea" class="form-control" id="mobile_no" placeholder="" value="" required="">
                  <div *ngIf="cosubmitted && co.mobile_no.errors" class="invalid-feedback">
                    <div *ngIf="co.mobile_no.errors.required">Mobile is required</div>
                    <div *ngIf="co.mobile_no.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
                 </div>
                </div>
               
                <div class="col-md-12 mb-12">
                  <label for="city">City<span>*</span></label>
                    <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="city" class="form-control" [ngClass]="{ 'is-invalid': cosubmitted && co.city.errors }" class="custom-select d-block w-100" id="city" name="city" required="">
                     <option value="">Choose...</option>
                     <option *ngFor="let city_type of contact_cities_types" [value]="city_type.id">{{city_type.name}}</option>
                   </select>
                    <div *ngIf="cosubmitted && co.city.errors" class="invalid-feedback">
                       <div *ngIf="co.city.errors.required"> City is required. </div>
                      
                    </div>
                 
                 </div>

            </div>
            <br/>
            <div class="row form-group">
              <div class="col-md-12 col-sm-12 mb-3 ">
                <button class="btn btn-sm btn-primary pull-right" style="float: right;" type="submit" id="btn-one" > Submit </button>
               
             </div>
           
           </div>  
          </form>
        </div>
       </div>
     </div>
   </div>


   <!-- VW creative -->
   <span id="vw_creative_form_msg"  data-toggle="modal" data-target="#vw_creative_form_msg_pop"></span>

   <div id="vw_creative_form_msg_pop" class="modal fade" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
     <div class="modal-dialog modal-dialog-centered"  role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <h5 class="modal-title">Volkswagen POWER LEASE</h5>
          <p>Below information will be forwarded Volkswagen or its partners subject to the company policy.</p>
        </div>
         <div class="modal-body">
          <p>Please Provide us your contact details.</p>
          <form [formGroup]="contactUsFormVo" (ngSubmit)="onContactUsSubmitVo()" enctype='multipart/form-data'>
            <div class="row form-group">
             

               <div class="col-md-6 mb-6">
                    <label for="first_name">Name<span>*</span> </label>
                    <input type="text" maxlength="25" name="first_name" formControlName="first_name" class="form-control" [ngClass]="{ 'is-invalid': vosubmitted && vo.first_name.errors }"  class="form-control" id="first_name" placeholder="" value="" required="">
                    <div *ngIf="vosubmitted && vo.first_name.errors" class="invalid-feedback">
                    <div *ngIf="vo.first_name.errors.required">Please enter a your name </div>
                    <div *ngIf="vo.first_name.errors.maxlength">please enter only 25 character</div>
                    <div *ngIf="vo.first_name.errors.minlength">please enter minimum 3 character</div>
                   </div> 
              </div> 
              
                
               


                <div class="col-md-6 mb-6">
                  <label for="mobile_no">Mobile Number <span>*</span> </label>
                  <input  formControlName="mobile_no" maxlength="10" class="form-control" [ngClass]="{ 'is-invalid': vosubmitted && vo.mobile_no.errors }" type="textarea" class="form-control" id="mobile_no" placeholder="" value="" required="">
                  <div *ngIf="vosubmitted && vo.mobile_no.errors" class="invalid-feedback">
                    <div *ngIf="vo.mobile_no.errors.required">Mobile is required</div>
                    <div *ngIf="vo.mobile_no.errors.pattern">Please, Enter 10 digit Mobile Number.</div>
                 </div>
                </div>
                <div class="col-md-6 mb-6">
                  <label for="email_id">Email ID <span>*</span> </label>
                  <input type="textarea" formControlName="email_id" name="email_id" class="form-control" [ngClass]="{ 'is-invalid': vosubmitted && vo.email_id.errors }" class="form-control" id="email_id" placeholder="" value="" required="">
                  
                  <div *ngIf="vosubmitted && vo.email_id.errors" class="invalid-feedback">
                   <div *ngIf="vo.email_id.errors.required"> Email id is required.</div>
                   <div *ngIf="vo.email_id.errors.email">Email must be a valid email address</div>
                </div>
                </div>
                <div class="col-md-6 mb-6">
                  <label for="city">Location<span>*</span></label>
                    <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="city" class="form-control" [ngClass]="{ 'is-invalid': vosubmitted && vo.city.errors }" class="custom-select d-block w-100" id="city" name="city" required="">
                     <option value="">Choose...</option>
                     <option *ngFor="let city_type of vo_cities_types" [value]="city_type.id">{{city_type.name}}</option>
                   </select>
                    <div *ngIf="vosubmitted && co.city.errors" class="invalid-feedback">
                       <div *ngIf="vo.city.errors.required">Location is required. </div>
                      </div>
                 
                 </div>

            </div>
            <br/>
            <div class="row form-group">
              <div class="col-md-12 col-sm-12 mb-3 ">
                <button class="btn btn-sm btn-primary pull-right" style="float: right;" type="submit" id="btn-one" > Submit </button>
               
             </div>
           
           </div>  
          </form>
        </div>
       </div>
     </div>
   </div>

   <!-- Ask for a demo -->
   <span id="ask_for_a_demo_form_msg"  data-toggle="modal" data-target="#ask_for_a_demo_form_msg_pop"></span>

   <div id="ask_for_a_demo_form_msg_pop" class="modal fade" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
     <div class="modal-dialog modal-xl modal-dialog-centered"   role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <h5 class="modal-title">Ask for a Demo</h5>
          </div>
         <div class="modal-body">
         
          <form [formGroup]="askForADemoForm"    (ngSubmit)="AskForADemoFormSubmitTab()" enctype='multipart/form-data'>
            
            <div class="row form-group">
             
  
               <div class="col-md-4 mb-4">
                    <label for="first_name">Name<span>*</span> </label>
                    <input type="text" maxlength="25" name="first_name" formControlName="first_name" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.first_name.errors }"  class="form-control" id="first_name" placeholder="" value="" required=true>
                    <div *ngIf="tabsubmitted && ask_demo.first_name.errors" class="invalid-feedback">
                    <div *ngIf="ask_demo.first_name.errors.required">Please enter a your name </div>
                    <div *ngIf="ask_demo.first_name.errors.maxlength">please enter only 25 character</div>
                    <div *ngIf="ask_demo.first_name.errors.minlength">please enter minimum 3 character</div>
                   </div> 
              </div> 
              
                
              <div class="col-md-4 mb-4">
                <label for="company_name">Company Name <span>*</span> </label>
                <input  formControlName="company_name"  class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.company_name.errors }" type="textarea" class="form-control" id="company_name" placeholder="" value="" required=true>
                <div *ngIf="tabsubmitted && ask_demo.company_name.errors" class="invalid-feedback">
                  <div *ngIf="ask_demo.company_name.errors.required">Please enter your company name</div>
                  
               </div>
              </div>
              <div class="col-md-4 mb-4">
                <label for="email_id"> Email Id <span>*</span> </label>
                <input type="textarea" formControlName="email_id" name="email_id" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.email_id.errors }" class="form-control" id="email_id" placeholder="" value="" required=true>
                
                <div *ngIf="tabsubmitted && ask_demo.email_id.errors" class="invalid-feedback">
                 <div *ngIf="ask_demo.email_id.errors.required">Please enter email id </div>
                 <div *ngIf="ask_demo.email_id.errors.pattern">Please enter valid email id</div>
              </div>
              </div>
  
                <div class="col-md-4 mb-4">
                  <label for="mobile_no"> Mobile Number <span>*</span> </label>
                  <input  formControlName="mobile_no" maxlength="10" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.mobile_no.errors }" type="textarea" class="form-control" id="mobile_no" placeholder="" value="" required=true>
                  <div *ngIf="tabsubmitted && ask_demo.mobile_no.errors" class="invalid-feedback">
                    <div *ngIf="ask_demo.mobile_no.errors.required">Please enter your mobile no.</div>
                    <div *ngIf="ask_demo.mobile_no.errors.pattern">Please enter 10 digit mobile no.</div>
                 </div>
                </div>
              
              
  
  
               
                <div class="col-md-4 mb-4">
                  <label for="city">Location<span>*</span></label>
                  
                    <select #mySelectCityChange    formControlName="city" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.city.errors }" class="custom-select d-block w-100" id="city" name="city" required=true>
                     <option value="">Choose...</option>
                     <option *ngFor="let city_type of demo_cities_types" [value]="city_type.id">{{city_type.name}}</option>
                   </select>
                    <div *ngIf="tabsubmitted && tab.city.errors" class="invalid-feedback">
                       <div *ngIf="ask_demo.city.errors.required">Please enter your location</div>
                      </div>
                 
                 </div>
  
                <div class="col-md-4 mb-4">
                  <label for="start_date_and_time">Demo Required on Date <span>*</span> </label>
                  <input type="text"
                  placeholder="MM-DD-YYYY"
                  #start_date
                  class="form-control"
                  name="start_date_and_time"
                  id="start_date_and_time"
                  formControlName="start_date_and_time"
                  value=""
                  required="" 
                  [ngClass]="{ 'is-invalid': tabsubmitted && ask_demo.start_date_and_time.errors }"
                  [minDate]="minimum_date_demo"
                  [maxDate]="maximum_date_demo"
                  bsDatepicker 
                  [bsConfig]="{ rangeInputFormat: 'MM-DD-YYYY',adaptivePosition: true, daysDisabled:[6,0] }" >
                  <div *ngIf="tabsubmitted && ask_demo.start_date_and_time.errors" class="invalid-feedback">
                    <div *ngIf="ask_demo.start_date_and_time.errors.required">Please select demo required on date</div>
                 </div>
                </div>
  
             
               
                 
  
            </div>
            <br/>
            <div class="row form-group">
              <div class="col-md-12 col-sm-12 mb-3 ">
                <div *ngIf="isSaving" id="preloader"><div data-loader="dual-ring"></div></div>
                <button class="btn btn-sm btn-primary pull-right"  style="float: right;"   type="submit" id="btn-one" > Submit </button>
               
             </div>
           
           </div>  
          </form>
        </div>
       </div>
     </div>
   </div>

 <!-- Take-a-rest creative -->
 <span id="take_a_break_creative_form_msg"  data-toggle="modal" data-target="#take_a_break_creative_form_msg_pop"></span>

 <div id="take_a_break_creative_form_msg_pop" class="modal fade" role="dialog" aria-hidden="true" data-backdrop="static" data-keyboard="false">
   <div class="modal-dialog modal-xl modal-dialog-centered"   role="document">
     <div class="modal-content">
      <div class="modal-header" style="display: block;
      align-items: flex-start;
      justify-content: space-between;
      padding: 1rem 1rem;
      border-bottom: 1px solid #e9ecef;
      border-top-left-radius: 0.3rem;
      border-top-right-radius: 0.3rem;
      padding-top: 9px;
      padding-bottom: 0px;">
        <h5 class="modal-title">TAKE A BREAK</h5>
        </div>
       <div class="modal-body">
       
        <form [formGroup]="contactUsFormTab"    (ngSubmit)="onContactUsSubmitTab()" enctype='multipart/form-data'>
          
          <div class="row form-group">
           

             <div class="col-md-4 mb-4">
                  <label for="first_name">Name<span>*</span> </label>
                  <input type="text" maxlength="25" name="first_name" formControlName="first_name" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.first_name.errors }"  class="form-control" id="first_name" placeholder="" value="" required="">
                  <div *ngIf="tabsubmitted && tab.first_name.errors" class="invalid-feedback">
                  <div *ngIf="tab.first_name.errors.required">Please enter a your name </div>
                  <div *ngIf="tab.first_name.errors.maxlength">please enter only 25 character</div>
                  <div *ngIf="tab.first_name.errors.minlength">please enter minimum 3 character</div>
                 </div> 
            </div> 
            
              
             


              <div class="col-md-4 mb-4">
                <label for="mobile_no"> Mobile Number <span>*</span> </label>
                <input  formControlName="mobile_no" maxlength="10" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.mobile_no.errors }" type="textarea" class="form-control" id="mobile_no" placeholder="" value="" required="">
                <div *ngIf="tabsubmitted && tab.mobile_no.errors" class="invalid-feedback">
                  <div *ngIf="tab.mobile_no.errors.required">Please enter your mobile no.</div>
                  <div *ngIf="tab.mobile_no.errors.pattern">Please enter 10 digit mobile no.</div>
               </div>
              </div>
              <div class="col-md-4 mb-4">
                <label for="email_id">Personal Email Id <span>*</span> </label>
                <input type="textarea" formControlName="email_id" name="email_id" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.email_id.errors }" class="form-control" id="email_id" placeholder="" value="" required="">
                
                <div *ngIf="tabsubmitted && tab.email_id.errors" class="invalid-feedback">
                 <div *ngIf="tab.email_id.errors.required">Please enter email id </div>
                 <div *ngIf="tab.email_id.errors.pattern">Please enter valid email id</div>
              </div>
              </div>
              <div class="col-md-4 mb-4">
                <label for="company_name">Company Name <span>*</span> </label>
                <input  formControlName="company_name"  class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.company_name.errors }" type="textarea" class="form-control" id="company_name" placeholder="" value="" required="">
                <div *ngIf="tabsubmitted && tab.company_name.errors" class="invalid-feedback">
                  <div *ngIf="tab.company_name.errors.required">Please enter your company name</div>
                  
               </div>
              </div>


              <div class="col-md-4 mb-4">
                <label for="city">Car<span>*</span></label>
                  <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="car" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.car.errors }" class="custom-select d-block w-100" id="car" name="car" required="">
                   <option value="">Choose...</option>
                   <option *ngFor="let city_type of tab_cities_types" [value]="city_type.id">{{city_type.name}}</option>
                 </select>
                  <div *ngIf="tabsubmitted && tab.car.errors" class="invalid-feedback">
                     <div *ngIf="tab.car.errors.required">Please select your car</div>
                    </div>
               
               </div>
             

              <div class="col-md-4 mb-4">
                <label for="start_date_and_time"> Pick-Up Date <span>*</span> </label>
                <input type="text"
                placeholder="MM-DD-YYYY"
                #start_date
                class="form-control"
                name="start_date_and_time"
                id="start_date_and_time"
                formControlName="start_date_and_time"
                value=""
                required="" 
                [ngClass]="{ 'is-invalid': tabsubmitted && tab.start_date_and_time.errors }"
                [minDate]="minimum_date"
                [maxDate]="maximum_date"
                bsDatepicker 
               [bsConfig]="{ rangeInputFormat: 'MM-DD-YYYY',adaptivePosition: true }" >
                <div *ngIf="tabsubmitted && tab.start_date_and_time.errors" class="invalid-feedback">
                  <div *ngIf="tab.start_date_and_time.errors.required">Please select pick-up date</div>
               </div>
              </div>

              <div class="col-md-4 mb-4">
                <label for="city">Pick-Up Time<span>*</span></label>
                  <select #mystart_time (change)='onMyStartTime(mystart_time.value)'   formControlName="start_time" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.start_time.errors }" class="custom-select d-block w-100" id="car" name="start_time" required="">
                   <option value="">Choose...</option>
                   <option *ngFor="let city_type of tab_report_types" [value]="city_type.id">{{city_type.name}}</option>
                 </select>
                  <div *ngIf="tabsubmitted && tab.start_time.errors" class="invalid-feedback">
                     <div *ngIf="tab.start_time.errors.required">Please select pick-up time</div>
                    </div>
               
               </div>
               
              <div class="col-md-4 mb-4">
                <label for="end_date_and_time">End Date <span>*</span> </label>
                <input type="text"
                placeholder="MM-DD-YYYY"
                class="form-control"
                name="end_date_and_time"
                id="end_date_and_time"
                formControlName="end_date_and_time"
                value=""
                required="" 
                [ngClass]="{ 'is-invalid': tabsubmitted && tab.end_date_and_time.errors }"
                [minDate]="minimum_date"
                [maxDate]="maximum_date"
                bsDatepicker 
               [bsConfig]="{ rangeInputFormat: 'MM-DD-YYYY',adaptivePosition: true }" >
                <div *ngIf="tabsubmitted && tab.end_date_and_time.errors" class="invalid-feedback">
                  <div *ngIf="tab.end_date_and_time.errors.required">Please select end date</div>
               </div>
              </div>

              <div class="col-md-4 mb-4">
                <label for="city">End  Time<span>*</span></label>
                  <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="end_report_time" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.end_report_time.errors }" class="custom-select d-block w-100" id="end_report_time" name="end_report_time" required="">
                   <option value="">Choose...</option>
                   <option *ngFor="let city_type of to_tab_report_types" [value]="city_type.id">{{city_type.name}}</option>
                 </select>
                  <div *ngIf="tabsubmitted && tab.end_report_time.errors" class="invalid-feedback">
                     <div *ngIf="tab.end_report_time.errors.required">Please select end report time</div>
                    </div>
               
               </div>
              <div class="col-md-4 mb-4">
                <label for="reporting_address_landmark">Reporting Address & Landmark <span>*</span> </label>
                <input  formControlName="reporting_address_landmark"  class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.reporting_address_landmark.errors }" type="textarea" class="form-control" id="reporting_address_landmark" placeholder="" value="" required="">
                <div *ngIf="tabsubmitted && tab.reporting_address_landmark.errors" class="invalid-feedback">
                  <div *ngIf="tab.reporting_address_landmark.errors.required">Please enter reporting address</div>
                  
               </div>
              </div>

               <div class="col-md-4 mb-4">
                <label for="destination_address_visit">Destination Address/Place of Visit <span>*</span> </label>
                <input  formControlName="destination_address_visit"  class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.destination_address_visit.errors }" type="textarea" class="form-control" id="destination_address_visit" placeholder="" value="" required="">
                <div *ngIf="tabsubmitted && tab.destination_address_visit.errors" class="invalid-feedback">
                  <div *ngIf="tab.destination_address_visit.errors.required">Please enter destination address</div>
                  
               </div>
              </div>

              <div class="col-md-4 mb-4">
                <label for="city">Location<span>*</span></label>
                  <select #mySelectCityChange (change)='onCityChangeChange(mySelectCityChange.value)'   formControlName="city" class="form-control" [ngClass]="{ 'is-invalid': tabsubmitted && tab.city.errors }" class="custom-select d-block w-100" id="city" name="city" required="">
                   <option value="">Choose...</option>
                   <option *ngFor="let city_type of tabs_cities_types" [value]="city_type.id">{{city_type.name}}</option>
                 </select>
                  <div *ngIf="tabsubmitted && tab.city.errors" class="invalid-feedback">
                     <div *ngIf="ask_demo.city.errors.required">Please enter your location</div>
                    </div>
               
               </div>
               

          </div>
          <div class="row form-group">
            <div class="col-md-12 col-sm-12 mb-3 ">
               <p  style="color:#0c2f54">*Our executive will get in touch with you within 24 hrs of receiving your request for futher details.</p>
                 <p style="color:#0c2f54">*Payment must be made in advance for the selected number of days, plus 18% GST.</p>
              </div>
            </div>
          <br/>
          <div class="row form-group">
            <div class="col-md-12 col-sm-12 mb-3 ">
              <div *ngIf="isSaving" id="preloader"><div data-loader="dual-ring"></div></div>
              <button class="btn btn-sm btn-primary pull-right"  style="float: right;"   type="submit" id="btn-one" > Submit </button>
             
           </div>
         
         </div>  
        </form>
      </div>
     </div>
   </div>
 </div>

 <span id="e_take_a_break"  data-toggle="modal" data-target="#e_take_a_break_pop"></span>

   <div id="e_take_a_break_pop" class="modal fade" role="dialog" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header" style="
        display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;
    ">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Information !!</h4>
        </div>
         <div class="modal-body">
              <p>End date should be greater then Start date</p>
             
            </div>
       </div>
     </div>
   </div>
   

   <span id="s_take_a_break"  data-toggle="modal" data-target="#s_take_a_break_pop"></span>

   <div id="s_take_a_break_pop" class="modal fade" role="dialog" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Information !!</h4>
        </div>
         <div class="modal-body">
              <p>Thanks for sharing your details</p>
             
            </div>
       </div>
     </div>
   </div>


   <span id="msg_ask_for_demo"  data-toggle="modal" data-target="#msg_ask_for_demo_pop"></span>

   <div id="msg_ask_for_demo_pop" class="modal fade" role="dialog" aria-hidden="true">
     <div class="modal-dialog modal-dialog-centered" role="document">
       <div class="modal-content">
        <div class="modal-header" style="display: block;
        align-items: flex-start;
        justify-content: space-between;
        padding: 1rem 1rem;
        border-bottom: 1px solid #e9ecef;
        border-top-left-radius: 0.3rem;
        border-top-right-radius: 0.3rem;
        padding-top: 9px;
        padding-bottom: 0px;">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Information !!</h4>
        </div>
         <div class="modal-body">
              <p>Thank you for sharing your details. We will connect with you, shortly.<br/> ORIX 24 x 7 Call Centre: +91 8796331265</p>
             
            </div>
       </div>
     </div>
   </div>